import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InfoUserService {
  @Output() setInf: EventEmitter<any> = new EventEmitter();

  idpersona: string;
  rolepersona: {
    Value: number;
    DisplayName: string;
  };
  constructor() { }


  public setPersona(id: string, rolepersona: {
    Value: number;
    DisplayName: string;
  }) {
    this.idpersona = id;
    this.rolepersona = rolepersona;
  }
}
